import Reports from 'components/Report/Workflows';
import React from 'react';
const WorkflowReports = () => {
  return (
      <Reports />
  );
};
export default WorkflowReports;
